var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextButtonBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_66779",
    "data-name": "Group 66779",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.613,
    height: 18.041,
    viewBox: "0 0 33.613 18.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66777",
    "data-name": "Group 66777",
    transform: "translate(0 6.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110807",
    "data-name": "Path 110807",
    d: "M20.187,17.906A2.307,2.307,0,1,1,17.881,15.6a2.307,2.307,0,0,1,2.307,2.307",
    transform: "translate(-7.574 -15.6)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110808",
    "data-name": "Path 110808",
    d: "M4.613,17.906A2.307,2.307,0,1,1,2.307,15.6a2.307,2.307,0,0,1,2.307,2.307",
    transform: "translate(0 -15.6)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110809",
    "data-name": "Path 110809",
    d: "M35.787,17.906A2.307,2.307,0,1,1,33.48,15.6a2.307,2.307,0,0,1,2.307,2.307",
    transform: "translate(-16.174 -15.6)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110810",
    "data-name": "Path 110810",
    d: "M51.386,17.906A2.307,2.307,0,1,1,49.08,15.6a2.307,2.307,0,0,1,2.307,2.307",
    transform: "translate(-24.773 -15.6)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110811",
    "data-name": "Path 110811",
    d: "M66.985,17.906A2.307,2.307,0,1,1,64.679,15.6a2.307,2.307,0,0,1,2.307,2.307",
    transform: "translate(-33.372 -15.6)",
    fill: "#000"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66778",
    "data-name": "Group 66778",
    transform: "translate(22 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110812",
    "data-name": "Path 110812",
    d: "M49.08,4.613a2.307,2.307,0,1,1,2.307-2.307A2.307,2.307,0,0,1,49.08,4.613",
    transform: "translate(-60.773)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110813",
    "data-name": "Path 110813",
    d: "M49.08,35.812a2.307,2.307,0,1,1,2.307-2.307,2.307,2.307,0,0,1-2.307,2.307",
    transform: "translate(-60.773 -17.771)",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextButtonBlack);
export default __webpack_public_path__ + "static/media/next-button-black.6d018bee7b99522f64cfc0259277da3a.svg";
export { ForwardRef as ReactComponent };